module.exports = __webpack_public_path__ + "static/img/shou.98cefe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shou.png
// module id = HOuS
// module chunks = 1